module.exports = __webpack_public_path__ + "img/IMG_1627_FoamcoreMatted.95acc94e.jpg";